import React, { useContext } from 'react';

// context
import { AdminDashboardContext } from '../../../../context/AdminDashboardContext.js';

// style
import './AdminDashboardHeader.css'

// icons
import logo from './fesb_unist_logo_white.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons'; // Import the solid gear icon


const AdminDashboardHeader = () => {

    const {setModalSettingsIsOpen } = useContext(AdminDashboardContext);

    const openModal = () => {
        setModalSettingsIsOpen(true);
    }

    return (  
        <div className="admin-dashboard-header-container">
            <img className="header-logo" src={logo} alt="header-logo"/>
            <button style={{border:"none", backgroundColor:"transparent"}}>
                <FontAwesomeIcon className="admin-dashboard-settings-icon" onClick={() => openModal()} icon={faCog} size="2x" color='#ffffff' />
            </button>
        </div>
    );
}
 
export default AdminDashboardHeader;